import { bl_sfa_deal_contact_hdr_link_RowClass } from "../../../dbschema/bl_sfa_deal_contact_hdr_link.model";
import { BaseContainerModel } from "../../base-container.model";

export class SfaDealContactHdrLinkContainerModel extends BaseContainerModel {
    bl_sfa_deal_contact_hdr_link: bl_sfa_deal_contact_hdr_link_RowClass = new bl_sfa_deal_contact_hdr_link_RowClass();
}